<template>
  <div class="boxPop">
    <van-popup
      v-model="show"
      closeable
      :close-on-click-overlay="false"
      @close="onClose"
    >
      <div class="popCenter">
        <h2>学习进度说明</h2>
        <ul>
          <li
            v-for="(item, index) in contentInstructions"
            :key="index"
          >
            {{item}}
          </li>
        </ul>

        <div
          class="closeEnter"
          @click="onClose"
          v-if="!personalSource"
        >确定</div>

      </div>
    </van-popup>

  </div>

</template>
<script>
export default {
  props: {
    contentInstructions: {
      type: Array,
      default: () => [],
    },
    // 来源个人中心学习报告
    personalSource: {
      type: Boolean,
      default: false,
    },

  },
  data() {
    return {
      show: true,

    };
  },
  watch: {},
  methods: {
    onClose() {
      this.$emit('popClose');
    },

  },
  created() { },
  mounted() {

  },
};
</script>
<style scoped lang="scss">
.boxPop {
  .popCenter {
    width: 634px;
    padding-bottom: 50px;
    background: #ffffff;
    border-radius: 14px;
    h2 {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
      line-height: 40px;
      text-align: center;
      padding-top: 30px;
    }
    ul {
      width: 100%;
      padding: 72px 33px;
      li {
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        line-height: 43px;
      }
    }
    .closeEnter {
      width: 308px;
      height: 80px;
      background: #ff7f41;
      border-radius: 14px;
      text-align: center;
      font-size: 29px;
      font-weight: 500;
      color: #ffffff;
      line-height: 80px;
      margin: 0 auto;
    }
  }
  ::v-deep .van-popup {
    border-radius: 8px;
  }
  ::v-deep .van-icon-cross:before {
    color: #333;
  }
}
</style>
